import { ICreateCaseRequest } from 'src/state/slice/models/CaseLifecycleTypes';
import { IAuthContext } from 'src/state/providers/AuthProvider';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { SustainabilityCreateCaseRequestImpl } from './RequestFactoryImpl/SustainabilityCreateCaseRequest';
import {
  PAGE_SCOPE,
  PROGRAM_ACCOUNTS,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import { IPageContext } from 'src/state/providers/PageProvider';

export interface IRequestGenerator {
  generateCreateCaseRequest(): ICreateCaseRequest;
}

export const buildCreateCaseRequest = (
  userContext: IAuthContext,
  pageContext: IPageContext,
  payload: any,
  additionalData: { [key: string]: string },
  attachments: DocumentDetails[],
  ddmAttributes: DDMAttributes,
): ICreateCaseRequest => {
  let createCaseRequest: ICreateCaseRequest;
  if (userContext.preferredAccountId === PROGRAM_ACCOUNTS.SUSTAINABLITY) {
    createCaseRequest = new SustainabilityCreateCaseRequestImpl(
      userContext,
      payload,
      additionalData,
      attachments,
      ddmAttributes,
    ).generateCreateCaseRequest();
  } else {
    createCaseRequest = {
      userId: userContext.customerId,
      accountId: userContext.preferredAccountId,
      clientId: userContext.clientId,
      ddmSchemaId: ddmAttributes.ddmSchemaId!,
      ddmSchemaVersion: ddmAttributes.ddmSchemaVersion!,
      caseTitle: payload.caseTitle,
      data: JSON.stringify(payload),
      documentList: attachments,
    };
  }
  if (additionalData?.caseLocale) {
    createCaseRequest = {
      ...createCaseRequest,
      caseLocale: additionalData.caseLocale,
    };
  }
  createCaseRequest = {
    ...createCaseRequest,
    isPublicPage: PAGE_SCOPE.PUBLIC === pageContext?.pageScope,
    isRegulatorCentralApp: userContext.clientId === UI_CLIENTS.RegulatorCentral,
  };
  return createCaseRequest;
};
